import Keycloak from 'keycloak-js';
import { log } from '../logConfig';

/**
 * Documentation of the Keycloak JS adapter:
 * https://www.keycloak.org/securing-apps/javascript-adapter
 *
 * Note: keycloak-js v26 uses native Promises (the legacy `.success()/.error()`
 * callback API was removed) and must be constructed with `new`.
 */
export const keycloak = new Keycloak('/api/keycloak-config');

export function logout() {
  keycloak.logout();
}

export function standardAuthentication(): Promise<void> {
  return keycloak.init({ onLoad: 'login-required' }).then(authenticated => {
    if (authenticated) {
      log.info('Authenticated!');
    } else {
      alert('could not authenticate, even after retry');
      throw new Error('Could not authenticate');
    }
  });
}

export function authToken(): Promise<string> {
  return keycloak.updateToken(10).then(refreshed => {
    log.debug('token valid');
    if (refreshed) {
      log.info('Token refreshed');
    }
    return keycloak.token!;
  }).catch(() => {
    log.warn('Could not update token');
    throw new Error('Could not update token');
  });
}
